(ns frontend.test.avatar
  (:require [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [basic-components.avatar :as avatar]))

(defmethod routing/render-view :test/avatar [{:keys [route-params]}]
  (let [account (->> @session/account)]
    [:div.container.bg-white.scroll.p-4
     [:h2.title-h2.mb-4 "Avatar"]
     [:span "To display a person profile image. It can either have a person image or display initials on the screen"]
     
     [:div.d-flex.align-items-center

      [:div.mr-4
       [avatar/view account "person-profile__circle--large"]]

      [:div.mr-4
       [avatar/view account "person-profile__circle--medium"]]

      [:div.mr-4
       [avatar/view account "person-profile__circle--small"]]

      [:div.mr-4
       [avatar/view account "person-profile__circle--xs-small"]]

      ]]))
